/**
 * @feature alert
 * @description Contains the reducer and dispatch actions for storing on-screen "toast" alerts.
 */

export { default as alertInitialState } from './initialState';
export { default as alertReducer } from './reducer';
export * from './actions';
export * from './types';